import { IconWrapper } from '../runtime';
export default IconWrapper('resume-assistant-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '6d272319' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.74565 5.25C8.27472 5.25 8.01227 5.79412 8.30544 6.16267L10.0915 8.40801L7.48233 14.2062C7.26583 14.6873 7.35844 15.2513 7.71744 15.6379L11.1757 19.3622C11.6208 19.8415 12.3794 19.8415 12.8245 19.3622L16.2828 15.6379C16.6418 15.2513 16.7344 14.6873 16.5179 14.2062L13.9086 8.40772L15.6944 6.16267C15.9876 5.79412 15.7251 5.25 15.2542 5.25H14.1784C13.7785 5.25 13.4003 5.4324 13.1513 5.74544L12.045 7.13621L12.0001 7.13629H11.9549L10.8486 5.74544C10.5996 5.4324 10.2214 5.25 9.82141 5.25H8.74565ZM12.0094 9.67022L11.9908 9.67022L9.78931 14.5625L12.0001 16.9434L14.2109 14.5625L12.0094 9.67022Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '6d272319',
      "x1": "0",
      "y1": "-9.15527e-05",
      "x2": "24",
      "y2": "23.9999",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#3DBFFF"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#009AE6"
    }
  })])])]);
});